import {
  searchPatientProspect,
  registerProspect,
  sendConsentData,
  sendConsentCode,
  getConsentPreview
} from "store/slices/selfEnrollment/selEnrollmentService";

import {
  initSearchProspect,
  setLoading,
  setProspect,
  setStep,
  setSubStep,
  searchProspectError,
  setServerError,
  setProspectExists,
  setMissingConsent,
  setCodeError,
  setConsentPreview,
  setCluster
} from "store/slices/selfEnrollment/selfEnrollmentSlice";

export const searchProspect = (dni) => async (dispatch) => {
  dispatch(initSearchProspect());
  try {
    const response = await searchPatientProspect(dni);
    if (response.status === 200) {
      if(response.data.patient.type === 'patient'){
        dispatch(setProspectExists(true));
      }
      if(response.data.patient.type === 'prospect' && response.data.hasConsentSignature){
        dispatch(setProspectExists(true));
      }
      if(response.data.patient.type === 'prospect' && !response.data.hasConsentSignature){
        dispatch(setProspect(response.data.patient));
        dispatch(setMissingConsent(true));
      }
    } else if (response.status === 404) {
        dispatch(setProspect({dni: dni}));
        dispatch(setSubStep('prospect-form'));
    }else{
      dispatch(searchProspectError(response.data.error));
    }
  } catch (error) {
    dispatch(searchProspectError(error));
  }
}

export const registerProspectAction = (prospect) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await registerProspect(prospect);
    if (response.status === 201) {
      dispatch(setProspect(response.data));
      dispatch(setSubStep('register-success'));
    } else if (response.status === 400) {
      dispatch(setServerError(response.data.message));
    } else {
      dispatch(setServerError(response.data.message));
    }
  } catch (error) {
    dispatch(searchProspectError(error));
  }
}

export const sendConsentDataAction = (prospect) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await sendConsentData(prospect);
    if (response.status === 200) {
      dispatch(setSubStep('consent-code-input'));
      dispatch(setLoading(false));
    } else {
      dispatch(setServerError(response.data.message));
    }
  } catch (error) {
    dispatch(setServerError(error));
  }
}

export const sendConsentCodeAction = (prospect, code) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await sendConsentCode(prospect, code);
    if (response.status === 200) {
      dispatch(setStep('finish'));
      dispatch(setSubStep('finish-success'));
      dispatch(setLoading(false));
    } else {
      dispatch(setCodeError("Código incorrecto"));
      dispatch(setLoading(false));
    }
  } catch (error) {
    dispatch(setServerError(error));
  }
}

export const requestNewCodeAction = (prospect) => async (dispatch) => {
  try {
    const response = await sendConsentData(prospect);
    if (response.status !== 200) {
      dispatch(setServerError(response.data.message));
    }
  } catch (error) {
    dispatch(setServerError(error));
  }
}

export const getConsentPreviewAction = (prospect) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await getConsentPreview(prospect);
    if (response.status === 200) {
        const blob = response.data;
        const objectUrl = URL.createObjectURL(blob);
        dispatch(setConsentPreview(objectUrl));
    } else {
      dispatch(setServerError(response.data.message));
    }
  } catch (error) {
    dispatch(setServerError(error));
  }
}

export const setStepAction = (step) => async (dispatch) => {
  dispatch(setStep(step));
}

export const setSubStepAction = (subStep) => async (dispatch) => {
  dispatch(setSubStep(subStep));
}

export const setProspectExistsAction = (exists) => async (dispatch) => {
  dispatch(setProspectExists(exists));
}

export const setMissingConsentAction = (missing) => async (dispatch) => {
  dispatch(setMissingConsent(missing));
}

export const backToSearchAction = () => async (dispatch) => {
  dispatch(setSubStep('prospect-search'));
  dispatch(setProspect(null));
}

export const setProspectAction = (updateProspect) => async (dispatch) => {
  dispatch(setProspect(updateProspect));
}

export const setServerErrorAction = (error) => async (dispatch) => {
  dispatch(setServerError(error));
}

export const setClusterAction = (cluster) => async (dispatch) => {
  dispatch(setCluster(cluster));
}